export const ToGroupSmsTypes = {
  GET_SMS_GROUP: "GET_SMS_GROUP",
  SEND_SMS_GROUP_PREVIEW: "SEND_SMS_GROUP_PREVIEW",
  SEND_SMS_GROUP: "SEND_SMS_GROUP",
};
